export const API_PREFIX = "api/";
export const ACCESS_TOKEN_KEY = "__ACCESS_TOKEN__";
export const AUTHORIZATION_KEY = "Authorization";
export const TOKEN_TYPE = "Bearer";
export const AJAX_COMPLETE = "ajaxComplete";
